import { HTTP_400_BAD_REQUEST_CODE } from "../constants/HttpStatusCode";
import { ORDER_TYPES } from "../constants/OrderValues";
import { FLAG } from "../constants/Constants";

/**
 * エラーの内容から、アクセストークンが期限切れかどうかを判定
 *
 * @param error
 * @return {bool}
 */
export const isExpiredAccessError = (error) => {
  return (
    error &&
    error.status === HTTP_400_BAD_REQUEST_CODE &&
    typeof error.data.message === "object" &&
    error.data.message["error"] === "invalid_grant"
  );
};

/**
 * 同期中かどうかを判定
 * @param {object} item LetterOrderモデルかFollowCallOrderモデル
 * @param {int} type
 * @return {bool}
 */
export const isSyncing = (item, type) => {
  if (type === ORDER_TYPES.LETTER) {
    return isCampaignSyncing(item) || isShippingStatusSyncing(item);
  }
  if (type === ORDER_TYPES.FOLLOW_CALL) {
    return isCampaignSyncing(item) || isCallHistorySyncing(item);
  }
  return false;
}

/**
 * 同期済みかどうかを判定
 * @param {object} item LetterOrderモデルかFollowCallOrderモデル
 * @param {int} type
 * @return {bool}
 */
export const isSynced = (item, type) => {
  if (type === ORDER_TYPES.LETTER) {
    return isCampaignSynced(item) && isShippingStatusSyncFlagOn(item) && !isShippingStatusSyncing(item) && !isShippingStatusSyncFailed(item);
  }
  if (type === ORDER_TYPES.FOLLOW_CALL) {
    return isCampaignSynced(item) && (!isFollowCalled(item) || (isCallHistorySyncFlagOn(item) && !isCallHistorySyncing(item) && !isCallHistorySyncFailed(item)));
  }
  return false;
}

/**
 * 同期失敗かどうかを判定
 * @param {object} item LetterOrderモデルかFollowCallOrderモデル
 * @param {int} type
 * @return {bool}
 */
export const isSyncFailed = (item, type) => {
  if (type === ORDER_TYPES.LETTER) {
    return isCampaignSyncFailed(item) || isShippingStatusSyncFailed(item);
  }
  if (type === ORDER_TYPES.FOLLOW_CALL) {
    return isCampaignSyncFailed(item) || isCallHistorySyncFailed(item);
  }
  return false;
}

/**
 * 一部同期済みかどうかを判定
 * @param {object} item LetterOrderモデルかFollowCallOrderモデル
 * @param {int} type
 * @return {bool}
 */
export const isPartSynced = (item, type) => {
  if (type === ORDER_TYPES.LETTER) {
    return isCampaignSynced(item) && !isShippingStatusSyncFlagOn(item) && !isShippingStatusSyncing(item);
  }
  if (type === ORDER_TYPES.FOLLOW_CALL) {
    return isCampaignSynced(item) && !isCallHistorySyncFlagOn(item) && !isCallHistorySyncing(item);
  }
  return false;
}

/**
 * フォローコールが行われたかどうかを判定
 * @param {object} item FollowCallOrderモデル
 * @return {bool}
 */
const isFollowCalled = (item) => {
  return item.latest_follow_called_timeline_status;
}

/**
 * キャンペーンが同期中かどうかを判定
 * @param {object} item LetterOrderモデルかFollowCallOrderモデル
 * @return {bool}
 */
const isCampaignSyncing = (item) => {
  return item.salesforce_sync_flag === FLAG.ON && item.salesforce_id === null;
}

/**
 * キャンペーンが同期失敗したかどうかを判定
 * @param {object} item LetterOrderモデルかFollowCallOrderモデル
 * @return {bool}
 */
const isCampaignSyncFailed = (item) => {
  return item.salesforce_sync_flag === FLAG.FAILED;
}

/**
 * キャンペーンが同期済みかどうかを判定
 * @param {object} item LetterOrderモデルかFollowCallOrderモデル
 * @return {bool}
 */
const isCampaignSynced = (item) => {
  return item.salesforce_sync_flag === FLAG.ON  && item.salesforce_id !== null;
}

/**
 * 発送ステータスの同期フラグがONかどうかを判定
 * @param {object} item LetterOrderモデル
 * @return {bool}
 */
const isShippingStatusSyncFlagOn = (item) => {
  return item.latest_letter_salesforce_sync_flag_on_timeline_status;
}

/**
 * 発送ステータスが同期済みかどうかを判定
 * @param {object} item LetterOrderモデル
 * @return {bool}
 */
const isShippingStatusSyncing = (item) => {
  return item.latest_letter_salesforce_syncing_timeline_status;
}

/**
 * 発送ステータスが同期失敗かどうかを判定
 * @param {object} item LetterOrderモデル
 * @return {bool}
 */
const isShippingStatusSyncFailed = (item) => {
  return item.latest_letter_salesforce_sync_failed_timeline_status;
}

/**
 * コール履歴の同期フラグがONかどうかを判定
 * @param {object} item FollowCallOrderモデル
 * @return {bool}
 */
const isCallHistorySyncFlagOn = (item) => {
  return item.latest_follow_call_salesforce_sync_flag_on_timeline_status;
}

/**
 * コール履歴の同期済みかどうかを判定
 * @param {object} item FollowCallOrderモデル
 * @return {bool}
 */
const isCallHistorySyncing = (item) => {
  return item.latest_follow_call_salesforce_syncing_timeline_status;
}

/**
 * コール履歴の同期失敗かどうかを判定
 * @param {object} item LetterOrderモデルかFollowCallOrderモデル
 * @return {bool}
 */
const isCallHistorySyncFailed = (item) => {
  return item.latest_follow_call_salesforce_sync_failed_timeline_status;
}



// WEBPACK FOOTER //
// ./src/utils/salesforceUtils.js